<template>
    <div class="custom-money-component">
        <div class="custom-money-item" v-if="!multiple">
            <el-input class="money-value" type="text" v-model="singleModel.value" placeholder="Valor"
                @keydown="formatValue" />

            <el-select class="money-type" placeholder="Moeda" v-model="singleModel.moneyType" @change="emitValue">
                <el-option v-for="item in optionsMoeda" :key="item.id" :label="item.descricao" :value="item.id"
                    :disabled="!item.ativo" />
            </el-select>
        </div>

        <div class="custom-money-item" v-for="(item, index) in model" v-if="multiple">
            <el-input class="money-value" type="text" v-model="item.value" placeholder="Valor" @keydown="formatValue" />

            <el-select class="money-type" placeholder="Moeda" v-model="item.moneyType" @change="emitValue">
                <el-option v-for="item in optionsMoeda" :key="item.id" :label="item.descricao" :value="item.id"
                    :disabled="!item.ativo" />
            </el-select>

            <button type="button" class="delete-money-item" @click="removeItem(index)" v-if="model.length != 1">
                <el-icon>
                    <CloseBold />
                </el-icon>
            </button>
        </div>

        <button type="button" class="custom-money-add-button" @click="addItem" v-if="multiple">
            <el-icon>
                <Plus />
            </el-icon>
            Adicionar Valor
        </button>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useStore } from 'vuex'

import { MoedaActions } from "@/store/enums/CadEnums"

export default defineComponent({
    name: "customMoney",

    props: {
        modelValue: null,

        maxLength: {
            type: Number,
            default: () => {
                return 20
            }
        },

        decimalLength: {
            type: Number,
            default: () => {
                return 2
            }
        },

        negativeValues: {
            type: Boolean,
            default: () => {
                return true
            }
        },

        multiple: {
            type: Boolean,
            default: () => {
                return false
            }
        }
    },

    emit: ['update:modelValue'],

    setup(props, { emit }) {
        const store = useStore()

        type customMoney = {
            value: string;
            moneyType: number
        }

        const model = ref<customMoney[]>([{
            value: '',
            moneyType: 1
        }])

        const singleModel = ref<customMoney>({
            value: '',
            moneyType: 1
        })

        const formatValue = (event) => {
            const input = event.target;
            const valorAtual = input.value;
            const tecla = event.key;

            // Verificar se a tecla pressionada é uma tecla de comando            
            const teclasDeComando = [
                "Backquote", "Minus", "Equal", "Backspace", "Tab",
                "BracketLeft", "BracketRight", "Backslash", "CapsLock",
                "Semicolon", "Quote", "Enter", "ShiftLeft", "IntlBackslash",
                "Comma", "Period", "Slash", "ShiftRight", "ControlLeft",
                "AltLeft", "Space", "AltRight", "ControlRight", "Escape",
                "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12",
                "Insert", "Home", "PageUp", "Delete", "End", "PageDown",
                "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"
            ];

            if (teclasDeComando.includes(tecla)) {
                return;
            }

            // Verificar se o valor inserido é um número válido
            const regexNumero = new RegExp(`^${props.negativeValues ? '-?' : ''}\\d{0,${props.maxLength - props.decimalLength}}(,\\d{0,${props.decimalLength}})?$`);

            if (!regexNumero.test(valorAtual + tecla)) {
                event.preventDefault();
            }

            // Verificar se o sinal de menos está no início e permitir apenas um
            if (tecla === '-' && valorAtual.indexOf('-') !== -1) {
                event.preventDefault();
            }

            // Verificar se a vírgula está presente e permitir apenas duas casas decimais após ela
            if (tecla === ',' && valorAtual.indexOf(',') !== -1) {
                const parteDecimal = valorAtual.split(',')[1];
                if (parteDecimal && parteDecimal.length >= props.decimalLength) {
                    event.preventDefault();
                }
            }

            emitValue()
        }

        //Combo Moedas
        const optionsMoeda = ref<any>(null);
        store.dispatch(MoedaActions.GETWITHDISABLED_MOEDA).then(res => {
            optionsMoeda.value = res.values;
        }).catch(err => {
            console.error(err);
        });

        const removeItem = (index) => {
            if (model.value.length > 1)
                model.value.splice(index, 1)
        }

        const addItem = () => {
            model.value.push({
                value: '',
                moneyType: 1
            })
        }

        const emitValue = () => {
            if (props.multiple)
                emit('update:modelValue', model.value)

            if (!props.multiple)
                emit('update:modelValue', singleModel.value)
        }

        return {
            // data
            model,
            singleModel,
            optionsMoeda,

            // methods
            formatValue,
            removeItem,
            addItem,
            emitValue
        }
    }
})
</script>

<style>
@import url(../../assets/less/custom-money-component/index.css)
</style>